var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDottedVerticalLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 62,
    viewBox: "0 0 2 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1 1L1 61",
    stroke: "#AAAECA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "0.1 6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDottedVerticalLine);
export default __webpack_public_path__ + "static/media/dotted-vertical-line.8b10a66ac19c2c7be3295482d31cada5.svg";
export { ForwardRef as ReactComponent };